import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';

import { Button } from 'devextreme-react/button';
//devextreem
import Form, { Item } from 'devextreme-react/form';
import TabPanel from 'devextreme-react/tab-panel';
import 'devextreme-react/text-area';
import ValidationGroup from 'devextreme-react/validation-group';

import { AppLayoutTop } from 'components/appComponents';
import { LoadPanel } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import $createStore from 'utils/create-store-instance';

import {
  useChangeEmployeeMutation,
  useCreateEmployeeMutation,
  useLazyGetEmployeeDetailQuery,
} from 'bus/employee/services/services';
import { EmployeeItem } from 'bus/employee/types';
import { FactoryDetail } from 'bus/factory/types';
import { PostItem } from 'bus/post/types';

import { History, MainInfo } from './components';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const initialForm = {
  id: 0,
  postId: null,
  surname: '',
  name: '',
  middleName: '',
  isResident: true,
  sex: 0,
  isOfficiallyEmployed: true,
  phone: '',
  email: '',
  comment: '',
  idDeleted: false,
  hasAccess: false,
  userName: '',
  password: '',
  roleId: null,
  factoryId: null,
  requisites: null,
  status: null,
  dateOfDismissal: '',
};

const storePost = $createStore('/v1/post', 'id');

const defaultFilter = ['parentId', '=', null];
const storeFactory = $createDataSource('/v1/factory', 'id', { defaultFilter });

const EmployeeDetail: FC = () => {
  let { id } = useParams<{ id: string }>();
  const history = useHistory();

  const [changeEmployee, { isLoading: isLoadingChange }] = useChangeEmployeeMutation();
  const [createEmployee, { isLoading: isLoadingCreate }] = useCreateEmployeeMutation();
  const [getEmployeeDetail, { isLoading: usLoadingDetail }] = useLazyGetEmployeeDetailQuery();

  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  let createCatalogGroupRef = useRef<Form | null>(null);
  let createCatalogGroupValidationRef = useRef<any>(null);

  const [posts, setPost] = useState<PostItem[]>([]);
  const [factory, setFactory] = useState<FactoryDetail[]>([]);

  const [formEmployee, setFormEmployee] = useState<EmployeeItem>({ ...initialForm });

  const loading = isLoadingChange || isLoadingCreate;

  const getInfo = async () => {
    const result = await getEmployeeDetail({ id });
    result.data && setFormEmployee({ ...result.data });
  };

  useEffect(() => {
    if (id) getInfo();
    storePost.load().then((res) => setPost(res as any));
    storeFactory.load().then((res) => setFactory(res));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupRef.current?.instance.validate().isValid) {
      if (id) {
        changeEmployee({ ...formEmployee, id: Number(id) })
          .unwrap()
          .then(() => {
            toast.success('Сотрудник успешно изменён', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          });
      } else {
        await createEmployee(formEmployee)
          .unwrap()
          .then(() => {
            toast.success('Сотрудник успешно создан', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            history.push('/employee/');
          });
      }
    }
  };

  const tabs = useMemo(
    () => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: 'История изменений',
        index: 1,
        visible: Boolean(id),
      },
    ],
    [id],
  );

  return (
    <div id="employee">
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#employee' }}
        visible={usLoadingDetail}
        showIndicator={true}
        shading={false}
        showPane={true}
        closeOnOutsideClick={false}
      />

      <form onSubmit={handleSubmit}>
        <ValidationGroup ref={createCatalogGroupValidationRef}>
          <AppLayoutTop title="Сотрудник">
            <Button width={120} text="Сохранить" type="success" useSubmitBehavior={true} disabled={loading} />
          </AppLayoutTop>

          <Form formData={formEmployee} ref={createCatalogGroupRef}>
            <Item colSpan={12} colCount={12} itemType="group">
              <TabPanel
                height="auto"
                dataSource={tabs}
                selectedIndex={selectedIndex}
                onOptionChanged={(e) => {
                  if (e.name === 'selectedIndex') {
                    setSelectedIndex(e.value);
                  }
                }}
                itemTitleRender={itemTitleRender}
                animationEnabled={false}
              />
              {selectedIndex === 0 && (
                <div className="tab-content">
                  <MainInfo
                    form={formEmployee}
                    changeForm={(eventForm) => {
                      if (eventForm.id !== undefined) setFormEmployee((prev) => ({ ...prev, ...eventForm }));
                    }}
                    storePost={posts}
                    storeFactory={factory}
                  />
                </div>
              )}
              {selectedIndex === 1 && <History />}
            </Item>
          </Form>
        </ValidationGroup>
      </form>
    </div>
  );
};

export default EmployeeDetail;
